<p class="titleStandardStyle">Please Sign Here</p>
<div #surface class="shipSignatureInside"></div>
<!-- <button class='k-button' (click)="export()">Export as PNG</button> -->
<button class='k-button' (click)="onClear()">Clear Signature</button>